import type { ReactNode } from 'react';
import { Skeleton, styled } from '@mui/material';
import {
  CardAppScreenshots,
  CardAppScreenshotWrapper,
} from '../../../../AppCard/CardAppScreenshots';

const FallbackImageContainer = styled('div')(({ theme }) => ({
  borderRadius: '12px',
  overflow: 'hidden',
  maxHeight: '190px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
}));

const CardScreenshotsContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

interface CardScreenshotsProps {
  appImages: {
    imageElements: ReactNode[];
    fallbackImageElement: ReactNode;
  };
  isLoading: boolean;
}

export const CardScreenshots = ({
  appImages,
  isLoading,
}: CardScreenshotsProps) => {
  const hasAppImages =
    appImages?.imageElements && appImages.imageElements.length > 0;

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={180}
        data-testid="app-card-screenshots-loading"
      />
    );
  }

  return (
    <CardAppScreenshots>
      {hasAppImages ? (
        <>
          {appImages.imageElements
            .slice(0, 3)
            .map((appImage: ReactNode, index: number) => {
              return (
                <CardScreenshotsContainer key={index}>
                  <CardAppScreenshotWrapper>
                    {appImage}
                  </CardAppScreenshotWrapper>
                </CardScreenshotsContainer>
              );
            })}
        </>
      ) : (
        <FallbackImageContainer>
          {appImages?.fallbackImageElement}
        </FallbackImageContainer>
      )}
    </CardAppScreenshots>
  );
};
